import * as types from '../constants/actionTypes';
import initialState from '../reducers/initialState';

// IMPORTANT: Note that with Redux, state should NEVER be changed.
// State is considered immutable. Instead,
// create a copy of the state passed and set new values on the copy.
// Note that I'm using Object.assign to create a copy of current state
// and update values on the copy.
export default function timeReducer(state = initialState.time, action) {
  let newState = state;

    if(!action.status) {
        newState = Object.assign({}, state, {
            loading: true
        });

        return newState;
    }

  switch (action.type) {
      case types.GET_TIME_SPENT_ON_PROJECT:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    time: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

      case types.GET_TIME_SPENT_ON_PROJECT_BY_USER:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    time: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

      case types.GET_TIME_SPENT_ON_TASK:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    time: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

      case types.GET_TIME_SPENT_ON_TASK_BY_USER:
            if (action.status === 'success'){
                action.data = JSON.parse(action.data);
                newState = Object.assign({}, state, {
                    timeSpent: action.data.timeSpent,
                    timeOvertimeSpent: action.data.timeOvertimeSpent,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            if (!action.status){
                newState = Object.assign({}, state, {
                    loading: true
                });
            }
            return newState;

      default:
          return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/app/reducers/timeReducer.js
 **/